import React, { FunctionComponent } from 'react';
import SignInForm from '@containers/App/user/auth/form/signIn';
import AuthLayout from '@containers/App/user/auth/layout';

const SignIn: FunctionComponent= () => {
	return (
		<AuthLayout>
			<SignInForm/>
		</AuthLayout>
	);
};

export default SignIn;
